var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agendamiento d-flex",style:({backgroundColor: _vm.color})},[_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.texto))]),_c('div',{staticClass:"ml-auto"},[_vm._v(_vm._s(_vm.texto_consecutivo))]),_c('div',{staticClass:"text-left",staticStyle:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.texto1))])])
}
var staticRenderFns = []

export { render, staticRenderFns }